import { FILTER_TYPE } from '../Filters.types'

import { UpdateFiltersProps } from './AdditionalFilters'
import FilterDropdown from './FilterDropdown'

interface Props {
  selectedFilters: { [key in FILTER_TYPE]: Array<string> }
  updateFilters: (values: UpdateFiltersProps) => () => void
  resetFilter: (type: FILTER_TYPE) => () => void
  handleApply: () => void
  undoFilterSelection: () => void
}

const FilterDropdowns = ({ selectedFilters, updateFilters, resetFilter, handleApply, undoFilterSelection }: Props) => (
  <>
    <FilterDropdown
      filterType={FILTER_TYPE.LOCATION_OFFERING}
      selectedFilters={selectedFilters[FILTER_TYPE.LOCATION_OFFERING]}
      updateFilters={updateFilters}
      resetFilter={resetFilter}
      handleApply={handleApply}
      undoFilterSelection={undoFilterSelection}
    />
    <FilterDropdown
      filterType={FILTER_TYPE.LEVEL}
      selectedFilters={selectedFilters[FILTER_TYPE.LEVEL]}
      updateFilters={updateFilters}
      resetFilter={resetFilter}
      handleApply={handleApply}
      undoFilterSelection={undoFilterSelection}
    />
  </>
)

export default FilterDropdowns
